module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-form"
  }, [_c('error-reveal', {
    attrs: {
      "error": _vm.error
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-8 columns"
  }, [_c('label', {
    attrs: {
      "id": "resolution"
    }
  }, [_vm._v("Felbontás:   \n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resolution),
      expression: "resolution"
    }],
    attrs: {
      "type": "radio",
      "name": "pokemon",
      "value": "days",
      "id": "resolution-days",
      "required": ""
    },
    domProps: {
      "checked": _vm._q(_vm.resolution, "days")
    },
    on: {
      "change": function($event) {
        _vm.resolution = "days"
      }
    }
  }), _c('label', {
    attrs: {
      "for": "resolution-days"
    }
  }, [_vm._v("napi")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resolution),
      expression: "resolution"
    }],
    attrs: {
      "type": "radio",
      "name": "pokemon",
      "value": "weeks",
      "id": "resolution-weeks"
    },
    domProps: {
      "checked": _vm._q(_vm.resolution, "weeks")
    },
    on: {
      "change": function($event) {
        _vm.resolution = "weeks"
      }
    }
  }), _c('label', {
    attrs: {
      "for": "resolution-weeks"
    }
  }, [_vm._v("heti")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resolution),
      expression: "resolution"
    }],
    attrs: {
      "type": "radio",
      "name": "pokemon",
      "value": "months",
      "id": "resolution-months"
    },
    domProps: {
      "checked": _vm._q(_vm.resolution, "months")
    },
    on: {
      "change": function($event) {
        _vm.resolution = "months"
      }
    }
  }), _c('label', {
    attrs: {
      "for": "resolution-months"
    }
  }, [_vm._v("havi")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-4 columns text-right"
  }, [_c('label', [_vm._v("Időszak: " + _vm._s(_vm.fmtFrom) + " - " + _vm._s(_vm.fmtTo))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-6 columns"
  }, [_c('table', {
    staticClass: "sum"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "200px",
      "text-align": "center"
    }
  }, [_vm._v("Metrika / Időszak")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "130px",
      "text-align": "center"
    }
  }, [_vm._v("Teljes időszak")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "130px",
      "text-align": "center"
    }
  }, [_vm._v("Kijelölés "), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "font-weight": "normal"
    }
  }, [_vm._v(_vm._s(_vm.fmtSelFrom) + " - " + _vm._s(_vm.fmtSelTo))])])]), _vm._v(" "), _vm._l((_vm.metrics), function(item) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalSum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.selectedSum))])])
  })], 2)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row expanded bottom"
  }, [_c('div', {
    staticClass: "small-4 columns"
  }, [_c('button', {
    staticClass: "button primary trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Letöltés")]), _vm._v(" "), _c('button', {
    staticClass: "button secondary trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Vissza")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "chart-container",
    staticStyle: {
      "clear": "both"
    },
    attrs: {
      "id": "chart"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-6 columns"
  }, [_c('div', {
    staticClass: "chart-container top-right",
    staticStyle: {
      "clear": "both"
    },
    attrs: {
      "id": "heatmap"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-392ecec6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/insights/Display.vue
// module id = 470
// module chunks = 2